import { useNavigate } from 'react-router-dom';

export default function GiftSection(){
  const navigate=useNavigate();
  return <section id="presentes" className="gift-reference">
    <div className="gift-photo"><img src="/assets/presente-yasmin.png" alt="Caixa de presente azul-marinho com laço"/></div>
    <div className="gift-copy">
      <img className="gift-title-art" src="/assets/lista-presentes-titulo.png" alt="Lista de Presentes"/>
      <p>Sua presença já é o maior presente, <br/>mas se quiser me presentear, preparei <br/>uma lista especial com muito carinho!</p>
      <button className="gift-button-art" onClick={()=>navigate('/lista-de-presentes')} aria-label="Ver lista de presentes">
        <svg className="gift-button-icon" viewBox="0 0 48 54" aria-hidden="true">
          <path d="M5 20h38v30H5zM2 14h44v9H2zM24 14v36M24 13C15 13 9 10 9 5c0-3 3-5 6-4 5 1 9 7 9 12Zm0 0c9 0 15-3 15-8 0-3-3-5-6-4-5 1-9 7-9 12Z"/>
        </svg>
        <span>VER LISTA DE PRESENTES</span>
        <svg className="gift-button-arrow" viewBox="0 0 28 20" aria-hidden="true"><path d="M1 10h24M18 3l7 7-7 7"/></svg>
      </button>
    </div>
  </section>
}
